import { Component, ViewChild, Output, EventEmitter } from '@angular/core';
import { IonSelect } from '@ionic/angular';
import { ZXingScannerComponent } from '@zxing/ngx-scanner';
import { ModalController } from '@ionic/angular';
import { Logger } from 'src/app/angular-wallet-base/services/logger.service';

@Component({
  selector: 'app-qr-scanner',
  templateUrl: './browser-scanner.component.html',
  styleUrls: ['./browser-scanner.component.scss'],
})
export class QrScannerComponent {
  @ViewChild('scanner') scanner: ZXingScannerComponent;
  availableDevices: MediaDeviceInfo[];
  selectedDevice: MediaDeviceInfo;
  selectedDeviceId: string;
  enableScanner = true;

  constructor(public modalCtrl: ModalController) {}

  ngAfterViewInit() {
    this.scanner.camerasFound.subscribe((devices: MediaDeviceInfo[]) => {
      this.availableDevices = devices;
      // selects the devices's back camera by default
      // typically the device has only one camera
      this.selectedDevice = devices[0];
      this.selectedDeviceId = devices[0].deviceId;
    });
    this.scanner.camerasNotFound.subscribe(() => console.error('An error occurred when trying to enumerate your video-stream-enabled devices.'));
    this.scanner.permissionResponse.subscribe((answer: boolean) => {
        Logger.info('Permission has been granted:', answer);
    });
  }

  onCodeResult(result: string) {
    this.modalCtrl.dismiss({
      scannedData: result
    });
    this.enableScanner = false;
  }

  onDeviceSelectChange(selectedValue: string) {
    //find devide by deviceId
    const device = this.availableDevices.find(device => device.deviceId === selectedValue);
    this.selectedDevice = device || null;
    this.selectedDeviceId = selectedValue;
  }
}
